import Vue from 'vue'
//下面引入的组件 都是全局注册的
import Header from '@/components/Header'
import Footer from "@/components/Footer"

// 放在数组里 方便下面的循环
var components = [Header, Footer]

//循环全局注入
components.forEach(component => {
  Vue.component(component.name, component)
});